import { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import logo from '../assets/nmslogo.jpeg';

const NAV_LINKS = [
  { id: 'home',      label: 'Home'        },
  { id: 'services',  label: 'Services'    },
  { id: 'portfolio', label: 'Case Studies'},
  { id: 'about',     label: 'About'       },
  { id: 'pricing',   label: 'Pricing'     },
  { id: 'blog',      label: 'Blog'        },
  { id: 'contact',   label: 'Contact'     },
];

export default function Navbar({ currentPage, navigate, openForm }) {
  const { dark, toggle } = useTheme();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <nav style={{
      position:     'fixed',
      top: 0, left: 0, right: 0,
      zIndex:       200,
      background:   scrolled ? 'rgba(6,9,18,0.96)' : 'transparent',
      backdropFilter: scrolled ? 'blur(20px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(255,255,255,0.06)' : 'none',
      transition:   'all 0.35s ease',
    }}>
      <div style={{
        maxWidth: 1180, margin: '0 auto', padding: '0 22px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        height: 68,
      }}>

        {/* ── Logo ── */}
        <button
          onClick={() => navigate('home')}
          style={{ background: 'none', border: 'none', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}
        >
          <div style={{ width: 42, height: 42, borderRadius: 10, overflow: 'hidden', background: '#000', flexShrink: 0 }}>
            <img src={logo} alt="NMS Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontFamily: 'Georgia, serif', fontWeight: 700, fontSize: 15, lineHeight: 1.1, color: 'var(--txt)' }}>Neural Media</div>
            <div style={{ fontSize: 9, color: 'var(--mut)', letterSpacing: '0.12em', fontWeight: 700 }}>SOLUTIONS</div>
          </div>
        </button>

        {/* ── Nav Links ── */}
        <div style={{ display: 'flex', gap: 2, alignItems: 'center' }} className="hide-mobile">
          {NAV_LINKS.map(({ id, label }) => (
            <button
              key={id}
              onClick={() => navigate(id)}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color:      currentPage === id ? 'var(--acc)' : 'var(--mut)',
                fontFamily: 'var(--fB)', fontWeight: 500, fontSize: 14,
                padding:    '8px 12px', borderRadius: 7,
                transition: 'color 0.2s',
                letterSpacing: '0.01em',
              }}
            >
              {label}
            </button>
          ))}
        </div>

        {/* ── Right side ── */}
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <button
            onClick={toggle}
            style={{
              background: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 8, width: 36, height: 36,
              display: 'grid', placeItems: 'center',
              fontSize: 15, cursor: 'pointer',
            }}
          >
            {dark ? '☀️' : '🌙'}
          </button>

          <button
            onClick={openForm}
            style={{
              padding: '9px 18px',
              background: 'var(--acc)', color: '#060912',
              border: 'none', borderRadius: 9,
              fontFamily: 'var(--fB)', fontWeight: 700, fontSize: 13,
              cursor: 'pointer', letterSpacing: '0.01em',
            }}
          >
            Get Free Consultation →
          </button>
        </div>
      </div>
    </nav>
  );
}
